import { LendingHome } from '@/types/lending';
import { SVSummaryCard } from '../core';
import { formatDateTimeFromUTC } from '@/utils/date';
import { formatCurrency } from '@/utils/currency';
import { titleCase } from '@/utils/stringCaser';

type LendingYachtDetailsProps = {
  loanRequest: LendingHome;
};

export default function LendingHomeDetails({
  loanRequest,
}: LendingYachtDetailsProps) {
  const {
    customerEmail,
    customerName,
    customerPhone,
    submittedAt,
    downPaymentAmount,
    purchasePrice,
    propertyPostalCode,
    propertyType,
    residencyUsage,
    estimatedCreditScore,
  } = loanRequest;

  return (
    <SVSummaryCard
      label="Mortgage Request Details"
      items={[
        { label: 'Name', text: customerName },
        { label: 'Email', text: customerEmail },
        { label: 'Phone', text: customerPhone },
        { label: 'Zip Code', text: propertyPostalCode },
        {
          label: 'Submitted At',
          text: formatDateTimeFromUTC(submittedAt),
        },
        {
          label: 'Purchase Amount',
          text: formatCurrency({ amount: purchasePrice.value }),
        },
        {
          label: 'Downpayment Amount',
          text: formatCurrency({ amount: downPaymentAmount.value }),
        },
        { label: 'Estimated Credit Score', text: estimatedCreditScore },
        { label: 'Property Type', text: titleCase(propertyType) },
        { label: 'Residency Usage', text: titleCase(residencyUsage) },
      ]}
    />
  );
}
